import React from 'react';
import { Box } from '@mui/material';
import AboutMissionVisionSection from './components/AboutMissionVisionSection/AboutMissionVisionSection';
import LivingRoomSection from './components/LivingRoomSection/LivingRoomSection';
import ValuesSection from './components/ValuesSection/ValuesSection';
// import TeamSection from './components/TeamSection/TeamSection';

const About = () => {
  return (
    <Box>
      <AboutMissionVisionSection />
      <LivingRoomSection />
      <ValuesSection />
      {/* <TeamSection /> */}
    </Box>
  );
};

export default About;

